const scheduledServicesUsersFilterModal = {
  "filter": "FILTERS",
  "clear": "Clear Filters",
  "site": "Sites",
  "role": "Roles",
  "cancel": "CANCEL",
  "ok": "APPLY",
}

export default scheduledServicesUsersFilterModal;